<template>
    <li :class="isMyNote ? 'my-note' : 'other-note'" class="note">
        <div :class="{ 'flex-end': isMyNote }" class="note__header">
            <span v-if="!isMyNote">{{ note.user_name }}</span>
            <span>{{ dateParser(note.date.split(' ')[0]) }}</span>
        </div>
        <div v-html="note.text" class="note__comment"></div>
    </li>
</template>

<script>
export default {
    props: {
        isMyNote: {
            type: Boolean,
            default: false
        },
        note: Object
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.note
    width: 95%
    padding: 10px 15px
    box-shadow: 1px 1px 3px 0px #8e8e8e
    border-radius: 20px
    &__header
        width: 100%
        font-size: 14px
        font-weight: 600
        margin-bottom: 5px
        color: #707070
        @include flex-between
    &__comment
        font-size: 16px
        pre
            white-space: pre-wrap
            white-space: -moz-pre-wrap
            white-space: -pre-wrap
            white-space: -o-pre-wrap
            word-wrap: break-word
            margin: 0
            padding: 0
            background: none
            border: none
            font: inherit
            font-size: inherit
            font-weight: inherit
            color: inherit
            h1
                font: inherit
                font-size: 14px
                font-weight: 600
                color: inherit
.my-note
    background: linear-gradient(13deg,#e9f9ff,#cddffa)
    border-bottom-right-radius: 0px
    margin-left: 5%
.other-note
    background: linear-gradient(-34deg,#f9f9f9,#e4e4e4)
    border-top-left-radius: 0px
    margin-right: 5%
.flex-end
    justify-content: flex-end
</style>